import { render } from "./LayouView.vue?vue&type=template&id=171f4a2b"
import script from "./LayouView.vue?vue&type=script&lang=js"
export * from "./LayouView.vue?vue&type=script&lang=js"

import "./LayouView.vue?vue&type=style&index=0&id=171f4a2b&lang=css&scope=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__